import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import termsUrl from "../../assets/legal/terms.md";

export default function Terms() {
  const [markdown, setMarkdown] = useState("");

  useEffect(() => {
    fetch(termsUrl)
      .then((res) => res.text())
      .then(setMarkdown);
  }, []);

  return (
    <div
      style={{
        padding: "2rem",
        maxWidth: "800px",
        margin: "0 auto",
        lineHeight: 1.6,
        color: "black",
        fontFamily: "Arial, sans-serif",
        textTransform: "none",
      }}
    >
      <ReactMarkdown>{markdown}</ReactMarkdown>
    </div>
  );
}
